export const MAP_TYPE = {
    SINGLE: 'single',
    CLUSTER: 'cluster'
};
